import Payload from '../../../components/customs/payload';
export default {
  getDashboardItemsActions({ commit }, payload) {
    commit('setDashboardItems', payload);
  },
  // ダッシュボード定数マス取得
  async getConstantListDataActions({ commit, dispatch }) {
    const params = new Payload('common-endpoint', '', 'getConstantList', [['REGION']]).data;
    const data = await dispatch('api/callAPI', params, { root: true });
    commit('setRegionConstantsMutations', data);
  },
};
